module.exports = __webpack_public_path__ + "img/magento-support-security.cae072ed.webp";